export default __webpack_public_path__ + "static/media/70.2e5c0fb2.png";